import { render, staticRenderFns } from "./Inboundlist-tow.vue?vue&type=template&id=ad6516d6&scoped=true&"
import script from "./Inboundlist-tow.vue?vue&type=script&lang=js&"
export * from "./Inboundlist-tow.vue?vue&type=script&lang=js&"
import style0 from "./Inboundlist-tow.vue?vue&type=style&index=0&id=ad6516d6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6516d6",
  null
  
)

export default component.exports